import { PersonAdd } from '@mui/icons-material';
import { Link } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import clsx from 'clsx';
import { EstateTaskInstance } from 'queries';

import Spinner from 'common/spinner';
import PortalUserDisplay from 'pages/common/portal/portal-user-display';
import PortalUsersAutocomplete, {
  UserAutoCompleteOption,
} from 'pages/common/portal/portal-users-autocomplete';

interface PointPersonCellProps extends GridRenderCellParams {
  assignedUsersUpdating: Record<string, boolean>;
  estateTaskInstanceIdUpdatingPointPerson: string | null;
  portalId: string;
  showPortalUsersAutocompleteElement: (id: string) => void;
  hidePortalUsersAutocompleteElement: (id: string) => void;
  handleAssignedUserChange: (
    elementId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _e: any,
    option: UserAutoCompleteOption | null,
  ) => void;
  classes: Record<string, string>;
}

export const PointPersonCell = ({
  row,
  assignedUsersUpdating,
  estateTaskInstanceIdUpdatingPointPerson,
  portalId,
  showPortalUsersAutocompleteElement,
  hidePortalUsersAutocompleteElement,
  handleAssignedUserChange,
  classes,
}: PointPersonCellProps) => {
  const estateTaskInstance = row as EstateTaskInstance;
  const isEditing = estateTaskInstanceIdUpdatingPointPerson === estateTaskInstance.id;
  const hasAssignedUser = !!estateTaskInstance.assignedUserId;

  if (assignedUsersUpdating[estateTaskInstance.id]) {
    return <Spinner />;
  } else {
    return (
      <>
        {!isEditing && !hasAssignedUser && (
          <Link
            className={clsx(classes.link, classes.addTeamMemberLink)}
            onClick={() => showPortalUsersAutocompleteElement(estateTaskInstance.id)}
          >
            <PersonAdd />
          </Link>
        )}

        {!isEditing && hasAssignedUser && (
          <Link
            className={classes.pointPersonLink}
            onClick={() => showPortalUsersAutocompleteElement(estateTaskInstance.id)}
          >
            <PortalUserDisplay userId={estateTaskInstance.assignedUserId!} />
          </Link>
        )}

        {isEditing && (
          <PortalUsersAutocomplete
            elementId={`assignedUserId_${estateTaskInstance.id}`}
            portalId={portalId}
            selectedUserId={estateTaskInstance.assignedUserId?.toString()}
            handleUserChange={handleAssignedUserChange}
            handleLoseFocus={() => hidePortalUsersAutocompleteElement(estateTaskInstance.id)}
            openByDefault
          />
        )}
      </>
    );
  }
};
